import { Component, OnInit } from '@angular/core';
import { apiUrlComponent } from '../common/api.url.component';
import { Router } from '@angular/router';
import { ApiService } from '../common/API/api.service';
import { NotifierService } from 'angular-notifier';
import * as $ from 'jquery';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { BackRestrict} from '../common/backRestrict'

declare var config;

@Component({
  selector: 'app-Trade-In-Pro',
  templateUrl: './Trade-In-Pro.component.html',
  styleUrls: ['./Trade-In-Pro.component.css']
})
export class TradeInProComponent implements OnInit {
  public Enterprisedata=[];
  private droppedItems = [];
 public EnterpriseID:any;
  public form: FormGroup;
  private NotAddedTestList =[];
  private GroupTestList = [];
  private ManageList = [];
  public UnusedTestList= [];
  private EnterprisePartnerID;
  EditClick: boolean;
  //editbtn: any;
  savebtn: any;
  GdData: boolean;
  private readonly notifier: NotifierService;
  Enterpriselist: any;
  EnterprisePartnerlist: any;
  modfyEnterprisePartnerList: any;
  showUL: boolean;
  AddGroupInfo: boolean;
  disabledSubmitBtn: boolean;
  deductionArray = [];
  deductionVal: any;
  myModal: boolean;
  DeductionInput: boolean;
  constructor(
    private router: Router, private _apiService: ApiService, private formbuilder: FormBuilder,private backrestrict:BackRestrict,

    private apiUrl: apiUrlComponent, notifierService: NotifierService,
  ) {
    this.notifier = notifierService;
  }



  ngOnChanges() {
    debugger;
  }
  ngOnInit() {
    this.EnterpriseID=48;
    this.backrestrict.clearBrowserBackHistory();
    this.getEnterprise_EnterprisePartner();
    this.GdData = true;
    this.savebtn = false;
    this.disabledSubmitBtn = true;
    //this.editbtn = true

  }
  showchildtest(id: any, tabId: any) {
    debugger;
    $('#child_' + id).slideToggle(200);
    $('#iconAngle' + tabId).toggleClass('fa-angle-up fa-angle-down');
  }

  manageGroups() {
    debugger;
    this.deductionArray = [];
    this.disabledSubmitBtn = true;
    this.ManageList = [];
    debugger;
    this.GroupTestList.forEach(element => {
      debugger;
      if (element.ChilTestData.length > 0) {
        element.ChilTestData.forEach(Childelement => {
          if (element.ChilTestData.length > 0) {
            this.ManageList.push(
              {                
              DeductionGroupName: element.DeductionGroupName,
              DeductionGroupID: element.DeductionGroupID,
              DiagnosticID: Childelement.DiagnosticID,
              DeductionPercentage: element.DeductionPercentage
              }
            )

          }
          else {
            this.ManageList.push(
              {                
                DeductionGroupName: element.DeductionGroupName,
                DeductionGroupID: element.DeductionGroupID,
                DiagnosticID: null,
                DeductionPercentage: element.DeductionPercentage        
              }
            )
          }
        });

      } else {
        this.ManageList.push(
          {
            DeductionGroupName: element.DeductionGroupName,
            DeductionGroupID: element.DeductionGroupID,
            DiagnosticID: null,
            DeductionPercentage: element.DeductionPercentage 
          }
        )

      }
    });
    debugger;
    var Parameters = {
      ManageList: this.ManageList,     
      EnterprisePartnerID: this.EnterprisePartnerID
    }

    this._apiService.post(config.urlpath + 'api/updateTradeInProTestGroups', Parameters).subscribe(result => {


      if (result.Success === true) {
        debugger;
        this.notifier.notify('success', 'Data Updated Successfully');
        this.getTestGrouping();
        this.ManageList = [];
        this.droppedItems = [];
        this.NotAddedTestList = [];
        this.GroupTestList = [];
        this.ManageList = [];
        this.GdData = true;
        this.EditClick = false;
        //this.editbtn = true;
        this.savebtn = false;

      }
      else {
        this.notifier.notify('error', 'An Error Occured');
        this.getTestGrouping();
        this.ManageList = [];
        this.ManageList = [];
        this.droppedItems = [];
        this.NotAddedTestList = [];
        this.GroupTestList = [];
        this.ManageList = [];
        this.GdData = true;
        this.EditClick = false;
        // this.editbtn = true;
        this.savebtn = false;

      }
    },
      error => {
        console.log(error);
      }
    );


  }

  getTestGrouping() {

    var Addbody = {
      EnterprisePartnerID: this.EnterprisePartnerID
    }
    
    this._apiService.post(config.urlpath + 'api/getTradeInProTestGroups', Addbody).subscribe(result => {
      if (result.Success === true) {
      debugger;
        this.NotAddedTestList = [];
        this.GroupTestList = [];
        this.showUL = true;
        this.NotAddedTestList = result.Data[0];
        this.UnusedTestList=[];
        this.UnusedTestList=result.Data[0];
      
        let GroupTest = this.uniqueGroup(result.Data[1], function (x) { return x.DeductionGroupName; });
        if (GroupTest.length > 0) {
         GroupTest.forEach(element => {
         
            let TestList = result.Data[1].filter(x => x.DeductionGroupName === element);
           var Index = TestList.findIndex(x => x.DiagnosticID === null);
            if (Index >= 0) {
              TestList.push(
                {
                  
                  DeductionGroupName: TestList[Index].DeductionGroupName,
                  DeductionGroupID: TestList[Index].DeductionGroupID,
                  DeductionPercentage: TestList[Index].DeductionPercentage,
                  DiagnosticName: TestList[Index].DiagnosticName,
                  DiagnosticID: TestList[Index].DiagnosticID,
                  bgClass: 'd-none',
                  Class: 'd-none'
                }

              )
              TestList.splice(Index, 1);
            }


            this.GroupTestList.push(
              {
                DeductionGroupName: element,
                DeductionGroupID: TestList[0].DeductionGroupID,
                DeductionPercentage: TestList[0].DeductionPercentage,
                ChilTestData: TestList,
                bgClass: ''
              }
            )
          });
        }
      }
      else {

      }
    },
      error => {
        console.log(error);
      }
    );
  }
  onItemDrop(e: any) {
    debugger;
    const DeductionGroupID = parseInt(e.nativeEvent.currentTarget.id);
    const GroupTest = this.GroupTestList.find(x => x.DeductionGroupID === DeductionGroupID);
    if((this.NotAddedTestList.filter(x => x.DiagnosticID === e.dragData.DiagnosticID).length) !== 0)
    {
      this.NotAddedTestList.splice(this.NotAddedTestList.indexOf(this.NotAddedTestList.find(row => row.DiagnosticID === e.dragData.DiagnosticID)), 1);
      this.isdisabledSubmitBtn();
    }
    else
    {
      if(e.dragData.DeductionGroupID===null)
      {
      this.GroupTestList.forEach(X => {
        if (X.ChilTestData.find(X => X.DiagnosticID == e.dragData.DiagnosticID)) {
          X.ChilTestData.splice(X.ChilTestData.indexOf(X.ChilTestData.find(row => row.DiagnosticID === e.dragData.DiagnosticID)), 1);
        }
    })
    this.isdisabledSubmitBtn();
  }
  }
    if ((GroupTest.ChilTestData.filter(x => x.DiagnosticID === e.dragData.DiagnosticID).length) === 0) {
      if(e.dragData.DeductionGroupID===null||e.dragData.DeductionGroupID===undefined)
      {
      GroupTest.ChilTestData.splice(0, 0, {
        DeductionGroupID: DeductionGroupID,
        DiagnosticID: e.dragData.DiagnosticID,
        DiagnosticName: e.dragData.DiagnosticName,
        bgClass: 'new-added-group '
      });
      this.isdisabledSubmitBtn();
    }
    }
   




  }
  onItemReturn(e: any) {
    debugger;
    this.onItemremove(e.dragData)
  }
  onItemremove(item: any) {
    debugger;

    if (this.NotAddedTestList.length > 0) {

      ;
      if ((this.NotAddedTestList.filter(x => x.DiagnosticID === item.DiagnosticID).length) === 0) {

        this.NotAddedTestList.splice(0, 0, {
          DiagnosticID: item.DiagnosticID,
          DiagnosticName: item.DiagnosticName,
          bgClass: 'new-added-group'
        });
        this.isdisabledSubmitBtn();
      }

    }
    else if (this.NotAddedTestList.length === 0) {
      this.NotAddedTestList.splice(0, 0, item);
      this.isdisabledSubmitBtn();
    }

    const dragTestData = this.GroupTestList.find(x => x.DeductionGroupID === item.DeductionGroupID);
    const childTestData = this.GroupTestList.find(x => x.DeductionGroupID === item.DeductionGroupID).ChilTestData;
    dragTestData.ChilTestData = childTestData.filter(x => x.DiagnosticID !== item.DiagnosticID);
    // if (this.NotAddedTestListOrg.filter(Y => Y.DiagnosticID === item.DiagnosticID).length > 0) {
    //   this.NotAddedTestList.splice(0, 0, {
    //     DiagnosticID: item.DiagnosticID,
    //     DiagnosticName: item.DiagnosticName,
    //     bgClass: ''
    //   });

    // }
    
    // else {
    //   this.NotAddedTestList.splice(0, 0, {
    //     DiagnosticID: item.DiagnosticID,
    //     DiagnosticName: item.DiagnosticName,
    //     bgClass: 'new-added-group'
    //   });

    // }
  }
  // onDropTestGroup(e: any) {
  //   debugger;
    
  //   this.isdisabledSubmitBtn();
  //   const GroupTest = this.GroupTestList.find(x => x.ParentID === e.TestID);
  //   this.GroupTestList.splice(0, 0, {
  //     ParentTest: e.dragData.Test,
  //     ParentID: e.dragData.TestID,
  //     Deduction: 0,
  //     ChilTestData: [],
  //     bgClass: 'new-added-group'
  //   });
  //   if (this.NotAddedTestList.find(X => X.TestID == e.dragData.TestID)) {
  //     this.NotAddedTestList.splice(this.NotAddedTestList.indexOf(this.NotAddedTestList.find(row => row.TestID === e.dragData.TestID)), 1);
  //   }
  //   // else{
  //   //   this.notifier.notify('warning', 'Not able to drag child to Direct Parent , first of all add in child Tests ');
  //   // }

  //   else {
  //     this.GroupTestList.forEach(X => {
  //       if (X.ChilTestData.find(X => X.TestID == e.dragData.TestID)) {
  //         X.ChilTestData.splice(X.ChilTestData.indexOf(X.ChilTestData.find(row => row.TestID === e.dragData.TestID)), 1);
  //       }
  //     })


  //   }
  // }

  onKey(event: any) {
    debugger;
    var dedVal = event.target.value;
    debugger;
    if (dedVal !== '') {
      if (dedVal > 100) {
        event.target.value = 100;
      } else {
        event.target.value = Number(event.target.value);
      }
    }
    else {
      event.target.value = 0;
    }


  }
  closemyModal() {
    // //this.myModal = false;
    // this.DeductionInput=false;
  }

  Reset() {
    this.disabledSubmitBtn = true;
    // this.editbtn = true
    this.savebtn = false;
    this.deductionArray = [];
    this.getTestGrouping();
    this.notifier.notify('success', 'Reset Successfully');
  }

  editDeduction(Id: any, parentID = null) {
    debugger;
    this.showEditTextToggle(Id);
    this.disabledSubmitBtn = true;

    if (this.deductionArray.length > 0) {
      for (var i = 0; this.GroupTestList.length > i; i++) {
        if ((this.deductionArray.find(X => X.DeductionGroupID === this.GroupTestList[i].DeductionGroupID)) === null) {
          this.deductionArray.splice(0, 0, {
            DeductionPercentage: parseInt($('#DeductionTB' + i).val()),
            UpdatedDeductionPercentage: parseInt($('#DeductionTB' + i).val()),
            ID: i,
            ParentID: this.GroupTestList[i].DeductionGroupID
          })
        }
      }

    }
    else {
      for (var i = 0; this.GroupTestList.length > i; i++) {
        this.deductionArray.push({
          DeductionPercentage: parseInt($('#DeductionTB' + i).val()),
          UpdatedDeductionPercentage: parseInt($('#DeductionTB' + i).val()),
          ID: i,
          DeductionGroupID: this.GroupTestList[i].DeductionGroupID
        })
      }
    }
    // this.savechanges(Id, parentID);



  }

  showEditTextToggle(Id: any) {
    $('#btnsave' + Id).toggleClass('d-inline-block');
    $('#btnEdit' + Id).toggleClass('d-none');
    $('#iconUndo' + Id).toggleClass('d-inline-block');
    $('#DeductionLB' + Id).toggleClass('d-none');
    $('#DeductionTB' + Id).toggleClass("d-inline-block");
  }
  undoDeduction(Id: any, DeductionGroupID: any) {
    this.savebtn = false;
    this.showEditTextToggle(Id);

    let deduction = this.deductionArray.find(x => x.DeductionGroupID == DeductionGroupID);
    $('#DeductionTB' + Id).val(deduction.DeductionPercentage)
    $('#DeductionLB' + Id).text('Deduction : ' + deduction.DeductionPercentage + '%')
    this.GroupTestList.filter(x => {
      if (x.DeductionGroupID == DeductionGroupID) {
        x.DeductionPercentage = parseInt(deduction.DeductionPercentage);
        x.bgClass = '';
      }
    })
    this.deductionArray.filter(x => {
      if (x.DeductionGroupID == DeductionGroupID) {
        x.UpdatedDeductionPercentage = parseInt(deduction.DeductionPercentage);
      }
    })
    // if (this.GroupTestList.filter(X => X.bgClass === '').length === this.GroupTestList.length) {
    //   this.disabledSubmitBtn = true;
    // }

   
    debugger;
    if (this.GroupTestList.filter(X => X.bgClass === "").length === this.GroupTestList.length
      || this.GroupTestList.filter(X => X.ChilTestData.filter(Y => Y.bgClass === 'd-none').length == X.ChilTestData.length).length===this.GroupTestList.length) {
      this.disabledSubmitBtn = false;
    }
    else{
      this.disabledSubmitBtn = true;
    }

  }

  savechanges(Id: any, DeductionGroupID) {
    var deductionval = parseInt($('#DeductionTB' + Id).val());
    if (deductionval <= 100 && deductionval >= 0) {
      this.showEditTextToggle(Id);
      debugger;
      if (this.deductionArray[Id].UpdatedDeductionPercentage !== parseInt($('#DeductionTB' + Id).val())) {
        this.GroupTestList[Id].DeductionPercentage = parseInt($('#DeductionTB' + Id).val());
        this.deductionArray[Id].UpdatedDeductionPercentage = parseInt($('#DeductionTB' + Id).val());
        this.GroupTestList[Id].bgClass = 'new-added-group'
        this.isdisabledSubmitBtn();
        let deduction = this.deductionArray.find(x => x.DeductionGroupID === DeductionGroupID);
        $('#DeductionTB' + Id).val(deduction.UpdatedDeductionPercentage)
        $('#DeductionLB' + Id).text('Deduction : ' + deduction.UpdatedDeductionPercentage + '%')
      }
      if (this.deductionArray[Id].DeductionPercentage === parseInt($('#DeductionTB' + Id).val())) {
        this.GroupTestList[Id].bgClass = '';
        // this.GroupTestList[Id].Deduction =deductionval;
      }

    }
    else {

      $('#validationModel').click();
      $('#DeductionTB' + Id).val('')
    }

  }

  isdisabledSubmitBtn() {
    debugger;
    var count = 0;
    for (var i = 0; this.GroupTestList.length > i; i++) {

      if ($('#DeductionTB' + i).attr('class') !== 'form-control d-none d-inline-block') {
        count++
      }

    }
    if (count === this.GroupTestList.length) {
      this.disabledSubmitBtn = false;
    }
    else {
      this.disabledSubmitBtn = true;
    }
  }

  // DeleteGroup(Id: any) {
  //   debugger;
  //   this.isdisabledSubmitBtn();
  //   var newList = []
  //   newList = this.GroupTestList.filter(x => x.ParentID === Id);
  //   newList.forEach(Y => {
  //     Y.ChilTestData.forEach(X => {
  //       if (X.TestID != null) {
  //         this.NotAddedTestList.splice(0, 0, {
  //           TestID: X.TestID,
  //           Test: X.Test,
  //           PercentageDeduction: null,
  //           bgClass: 'new-added-group'
  //         });
  //       }

  //     })
  //     this.NotAddedTestList.splice(0, 0, {
  //       TestID: Y.ParentID,
  //       Test: Y.ParentTest,
  //       PercentageDeduction: null,
  //       bgClass: 'new-added-group'
  //     });
  //   })
  //   this.GroupTestList.splice(this.GroupTestList.indexOf(this.GroupTestList.find(row => row.ParentID === Id)), 1);

  // }


  uniqueGroup(arr, fn) {
    var unique = {};
    var distinct = [];
    arr.forEach(function (x) {
      var key = fn(x);
      if (!unique[key]) {
        distinct.push(key);
        unique[key] = true;
      }
    });
    return distinct;
  }

  getEnterprise_EnterprisePartner() {
    debugger;
    this._apiService.get(config.urlpath + 'api/getstore').subscribe(result => {
      debugger;
      if (result.Success === true) {        
        this.Enterpriselist = (result.Data[1].filter(X=>X.IsActive!==false));
        debugger;
        this.EnterprisePartnerlist = (result.Data[2].filter(X=>X.IsActive!==false)); /*&&X.TestProfileID!==2*/
        //this.Enterprisedata=result.Data[0][35];
        for (let i = 0; i < 3; i++) {
          let filterResult: any = result.Data[i].filter(u => 
            u.EnterpriseID == this.EnterpriseID);
          
          console.log(JSON.stringify(filterResult));
          this.Enterprisedata=filterResult;
        }
        
      
      }
      else {
        
      }
    },
      error => {
        console.log(error);
      }
    );
  }
  onChangeEnterprise(event) {
    debugger;
    debugger;
    this.showUL = false;
    var EnterpriseID = event;
    this.modfyEnterprisePartnerList = this.EnterprisePartnerlist.filter((item) => item.EnterpriseID == EnterpriseID);

  }
  onChangeEnterprisePartner(event) {
    debugger;
    this.showUL = false;
    this.EnterprisePartnerID = event;
    this.getTestGrouping();
  }
  keyPressNumbers(event: any) {
    debugger;
    const pattern = /^[0-9]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
